import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const filtersTitleStyle: SxProps<Theme> = {
  fontWeight: YodaFontWeight.bold,
  fontSize: YodaFontSize.xLarge,
  marginBottom: YodaSpacing.medium,
};

export const cepTemplateCreationModeStyle: SxProps<Theme> = {
  width: '100%',
  gap: YodaSpacing.small,

  '& .MuiFormControlLabel-root': {
    flex: 1,
    borderRadius: YodaBorderRadius.small,
    border: `1px ${YodaColors.textSecondary} solid`,
    paddingX: YodaSpacing.small,
    paddingY: YodaSpacing.xxxSmall,
    minWidth: '400px',
    margin: 0,
    color: YodaColors.textSecondary,

    '&:hover': {
      borderColor: YodaColors.blue7,
      color: YodaColors.textPrimary,
    },

    '&.Mui-disabled': {
      borderColor: YodaColors.gray1,
    },

    '&:has(.Mui-checked)': {
      borderWidth: '2px',
      borderColor: YodaColors.blue7,
      color: YodaColors.textPrimary,
    },
  },

  '& .MuiRadio-colorPrimary.Mui-checked': {
    color: YodaColors.blue7,
  },

  '& .MuiFormControlLabel-label': {
    flex: 1,
    fontWeight: YodaFontWeight.regular,
    fontSize: YodaFontSize.medium,
  },
};
